// @ts-nocheck
import { populate } from 'populate';
import type { Container, NineSlicePlane, Sprite, Text } from 'pixi.js';
import { OutOfSpaceProgressLayout } from './failFlow/OutOfSpaceProgressLayout';
import { AreYouSureLayout } from './failFlow/AreYouSureLayout';
import { YouLostALifeLayout } from './failFlow/YouLostALifeLayout';
import { ButtonExtraLargeLayout } from '../common/buttons/ButtonExtraLargeLayout';

const raw = {
  list: [
    {
      id: 'fab7a3bd-cd80-4d5e-aef0-365def3347a4',
      type: 'Container',
      name: 'root',
      className: '',
      x: 0,
      y: 0,
      scale: {
        x: 1,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      angle: 0,
      alpha: 1,
      visible: true,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      parent: ''
    },
    {
      id: '9aaaf1b6-030f-4d79-bcf7-db93bec1bb3d',
      type: 'Container',
      name: 'popup',
      className: '',
      x: 365,
      y: 441,
      scale: {
        x: 1,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      angle: 0,
      alpha: 1,
      visible: true,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      parent: 'fab7a3bd-cd80-4d5e-aef0-365def3347a4',
      stateByName: {
        adButton: {
          y: 400
        }
      }
    },
    {
      id: 'dd797c47-1de3-4bc1-a3dc-5b1f0ac3c524',
      type: 'NineSlicePlane',
      name: 'background',
      className: '',
      x: -359,
      y: -408,
      scale: {
        x: 1,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      width: 729,
      height: 796,
      leftWidth: 73,
      topHeight: 73,
      rightWidth: 73,
      bottomHeight: 73,
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'PopUp_Background_9Slice_73x73x73x73',
      parent: '9aaaf1b6-030f-4d79-bcf7-db93bec1bb3d',
      stateByName: {
        adButton: {
          height: 831
        }
      }
    },
    {
      id: 'dc332095-4dce-4402-a1fe-91029dac7a08',
      type: 'Sprite',
      name: '',
      className: '',
      x: 0,
      y: -400,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'Header_Red',
      parent: '9aaaf1b6-030f-4d79-bcf7-db93bec1bb3d'
    },
    {
      id: '974f725e-fe40-4f83-8244-5aabf2ecd573',
      type: 'Container',
      name: 'outOfSpaceContainer',
      className: '',
      x: 0,
      y: 0,
      scale: {
        x: 1,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      angle: 0,
      alpha: 1,
      visible: true,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      parent: '9aaaf1b6-030f-4d79-bcf7-db93bec1bb3d'
    },
    {
      id: '3dddf54c-5f4e-4f66-bce1-fa8ba71ed625',
      type: 'Container',
      name: 'areYouSureContainer',
      className: '',
      x: 0,
      y: 0,
      scale: {
        x: 1,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      angle: 0,
      alpha: 1,
      visible: true,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      parent: '9aaaf1b6-030f-4d79-bcf7-db93bec1bb3d',
      stateByName: {
        retryFlow: {
          alpha: 1,
          visible: true
        }
      }
    },
    {
      id: 'b072aa80-294b-4346-b14e-9e3d226ff3b2',
      type: 'Container',
      name: 'lifeLostContainer',
      className: '',
      x: 0,
      y: 0,
      scale: {
        x: 1,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      angle: 0,
      alpha: 1,
      visible: true,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      parent: '9aaaf1b6-030f-4d79-bcf7-db93bec1bb3d'
    },
    {
      id: '69551968-9529-4083-9063-7d6a04eee1ba',
      type: 'Sprite',
      name: 'closeButton',
      className: '',
      x: 315,
      y: -392,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: true,
      hitArea: {
        type: 'Rectangle',
        x: -72,
        y: -72,
        width: 152,
        height: 161
      },
      texture: 'Close_Button',
      parent: '9aaaf1b6-030f-4d79-bcf7-db93bec1bb3d',
      data: {
        tapSound: 'UI_Button_Click'
      }
    },
    {
      id: '0ee2f63e-f667-46ca-9ec5-bea53af51e77',
      type: 'Container',
      name: 'playButton',
      className: '',
      x: 4,
      y: 230,
      scale: {
        x: 1,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      angle: 0,
      alpha: 1,
      visible: true,
      interactive: true,
      buttonMode: true,
      hitArea: {
        type: 'None'
      },
      parent: '9aaaf1b6-030f-4d79-bcf7-db93bec1bb3d',
      data: {
        tapSound: 'UI_Button_Click'
      },
      stateByName: {
        retryFlow: {
          visible: false
        },
        adButton: {
          y: 300
        },
        retryFlowUnlimitedLives: {
          visible: false,
          alpha: 0
        }
      }
    },
    {
      id: '0aaa51df-815a-4ca6-97c2-f10a31c94291',
      type: 'Container',
      name: 'adButton',
      className: '',
      x: 4,
      y: 383,
      scale: {
        x: 1,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      angle: 0,
      alpha: 1,
      visible: false,
      interactive: true,
      buttonMode: true,
      hitArea: {
        type: 'None'
      },
      parent: '9aaaf1b6-030f-4d79-bcf7-db93bec1bb3d',
      data: {
        tapSound: 'UI_Button_Click'
      },
      stateByName: {
        retryFlow: {
          visible: false
        },
        adButton: {
          visible: true,
          y: 130
        }
      }
    },
    {
      id: 'f7dc1155-12bf-4cd6-8eb7-5df882f78122',
      type: 'Container',
      name: 'retryButton',
      className: '',
      x: 4,
      y: 230,
      scale: {
        x: 1,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      angle: 0,
      alpha: 0,
      visible: false,
      interactive: true,
      buttonMode: true,
      hitArea: {
        type: 'None'
      },
      parent: '9aaaf1b6-030f-4d79-bcf7-db93bec1bb3d',
      data: {
        tapSound: 'UI_Button_Click'
      },
      stateByName: {
        retryFlow: {
          visible: true,
          alpha: 0,
          y: 230
        },
        adButton: {
          y: 270
        },
        retryFlowUnlimitedLives: {
          y: 230
        }
      }
    },
    {
      id: 'b83ced11-0a9e-4908-879d-cfc917262a5f',
      type: 'Container',
      name: 'quitButton',
      className: '',
      x: 4,
      y: 230,
      scale: {
        x: 1,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      angle: 0,
      alpha: 0,
      visible: false,
      interactive: true,
      buttonMode: true,
      hitArea: {
        type: 'None'
      },
      parent: '9aaaf1b6-030f-4d79-bcf7-db93bec1bb3d',
      data: {
        tapSound: 'UI_Button_Click'
      },
      stateByName: {
        retryFlow: {
          visible: true,
          alpha: 1
        },
        retryFlowUnlimitedLives: {
          alpha: 1,
          visible: true
        }
      }
    },
    {
      id: '08caafda-151d-423b-ba2b-73da5f2dbba7',
      type: 'Container',
      name: 'offerSlot',
      className: '',
      x: 0,
      y: 590,
      scale: {
        x: 0.9,
        y: 0.9
      },
      pivot: {
        x: 0,
        y: 0
      },
      angle: 0,
      alpha: 1,
      visible: true,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      parent: '9aaaf1b6-030f-4d79-bcf7-db93bec1bb3d',
      stateByName: {
        adButton: {
          y: 625,
          scale: {
            y: 0.85,
            x: 0.85
          }
        }
      }
    },
    {
      id: '0b9aa42b-c263-4891-bd31-aa10f3984b2f',
      type: 'Layout',
      name: 'outOfSpaceLayout',
      className: '',
      path: 'popups/failFlow/OutOfSpaceProgressLayout.ts',
      percentX: 0,
      percentY: 0,
      handleResize: false,
      x: 0,
      y: -91,
      scale: {
        x: 1,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      angle: 0,
      alpha: 1,
      visible: true,
      interactive: false,
      buttonMode: false,
      parent: '974f725e-fe40-4f83-8244-5aabf2ecd573',
      stateByName: {
        retryFlow: {
          visible: true,
          alpha: 1
        }
      }
    },
    {
      id: '9cd5aa3e-5196-4375-a861-4c4ea3dd3aaa',
      type: 'Text',
      name: 'outOfSpaceTitle',
      className: '',
      x: -2.85,
      y: -410,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      scale: {
        x: 0.95,
        y: 0.95
      },
      angle: 0,
      alpha: 1,
      visible: true,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      text: 'Out of Space',
      localize: true,
      maxWidth: 436,
      maxHeight: 168,
      maxFontSize: 0,
      icons: [],
      style: {
        fontSize: 65,
        fontWeight: 'normal',
        fontFamily: 'Baloo{wf}',
        fill: 'white',
        stroke: '0x75000D',
        strokeThickness: 7,
        align: 'left',
        wordWrap: false,
        wordWrapWidth: 100,
        breakWords: false,
        lineHeight: 0,
        padding: 0,
        fontStyle: 'normal',
        dropShadow: false,
        dropShadowAlpha: 1,
        dropShadowAngle: 0,
        dropShadowBlur: 0,
        dropShadowColor: 'black',
        dropShadowDistance: 5,
        leading: 0,
        lineJoin: 'round',
        miterLimit: 10,
        trim: false,
        textBaseline: 'alphabetic',
        whiteSpace: 'pre',
        fontVariant: 'normal',
        letterSpacing: 0,
        fillGradientStops: [],
        fillGradientType: 0
      },
      parent: '974f725e-fe40-4f83-8244-5aabf2ecd573',
      stateByName: {
        retryFlow: {
          alpha: 0
        },
        retryFlowUnlimitedLives: {
          alpha: 0
        }
      }
    },
    {
      id: '3ef068b3-2ca2-4dd3-a44c-d55ea3bcda29',
      type: 'Layout',
      name: 'areYouSureLayout',
      className: '',
      path: 'popups/failFlow/AreYouSureLayout.ts',
      percentX: 0,
      percentY: 0,
      handleResize: false,
      x: 0,
      y: -91,
      scale: {
        x: 1,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      angle: 0,
      alpha: 0,
      visible: true,
      interactive: false,
      buttonMode: false,
      parent: '3dddf54c-5f4e-4f66-bce1-fa8ba71ed625',
      stateByName: {
        retryFlowUnlimitedLives: {
          alpha: 0
        }
      }
    },
    {
      id: '7f152f15-3034-4529-bbcb-1be3c7e717e2',
      type: 'Text',
      name: 'secondTitle',
      className: '',
      x: -2.85,
      y: -410,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      scale: {
        x: 0.95,
        y: 0.95
      },
      angle: 0,
      alpha: 0,
      visible: true,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      text: 'Are You Sure?',
      localize: true,
      maxWidth: 446,
      maxHeight: 168,
      maxFontSize: 0,
      icons: [],
      style: {
        fontSize: 65,
        fontWeight: 'normal',
        fontFamily: 'Baloo{wf}',
        fill: 'white',
        stroke: '0x75000D',
        strokeThickness: 7,
        align: 'left',
        wordWrap: false,
        wordWrapWidth: 100,
        breakWords: false,
        lineHeight: 0,
        padding: 0,
        fontStyle: 'normal',
        dropShadow: false,
        dropShadowAlpha: 1,
        dropShadowAngle: 0,
        dropShadowBlur: 0,
        dropShadowColor: 'black',
        dropShadowDistance: 5,
        leading: 0,
        lineJoin: 'round',
        miterLimit: 10,
        trim: false,
        textBaseline: 'alphabetic',
        whiteSpace: 'pre',
        fontVariant: 'normal',
        letterSpacing: 0,
        fillGradientStops: [],
        fillGradientType: 0
      },
      parent: '3dddf54c-5f4e-4f66-bce1-fa8ba71ed625',
      stateByName: {
        retryFlow: {
          alpha: 1
        },
        retryFlowUnlimitedLives: {
          alpha: 1
        }
      }
    },
    {
      id: 'bf2efa04-946b-4ecc-9256-42b8d1afcc47',
      type: 'Layout',
      name: 'lifeLostLayout',
      className: '',
      path: 'popups/failFlow/YouLostALifeLayout.ts',
      percentX: 0,
      percentY: 0,
      handleResize: false,
      x: 0,
      y: -91,
      scale: {
        x: 1,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      angle: 0,
      alpha: 0,
      visible: true,
      interactive: false,
      buttonMode: false,
      parent: 'b072aa80-294b-4346-b14e-9e3d226ff3b2'
    },
    {
      id: '687e9dac-fcff-4782-bfab-3dd719cfc10e',
      type: 'Text',
      name: 'thirdTitle',
      className: '',
      x: -2.85,
      y: -410,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      scale: {
        x: 0.95,
        y: 0.95
      },
      angle: 0,
      alpha: 0,
      visible: true,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      text: 'You Lost a Life!',
      localize: true,
      maxWidth: 422,
      maxHeight: 168,
      maxFontSize: 0,
      icons: [],
      style: {
        fontSize: 65,
        fontWeight: 'normal',
        fontFamily: 'Baloo{wf}',
        fill: 'white',
        stroke: '0x75000D',
        strokeThickness: 7,
        align: 'left',
        wordWrap: false,
        wordWrapWidth: 100,
        breakWords: false,
        lineHeight: 0,
        padding: 0,
        fontStyle: 'normal',
        dropShadow: false,
        dropShadowAlpha: 1,
        dropShadowAngle: 0,
        dropShadowBlur: 0,
        dropShadowColor: 'black',
        dropShadowDistance: 5,
        leading: 0,
        lineJoin: 'round',
        miterLimit: 10,
        trim: false,
        textBaseline: 'alphabetic',
        whiteSpace: 'pre',
        fontVariant: 'normal',
        letterSpacing: 0,
        fillGradientStops: [],
        fillGradientType: 0
      },
      parent: 'b072aa80-294b-4346-b14e-9e3d226ff3b2',
      stateByName: {
        retryFlow: {
          alpha: 0
        }
      }
    },
    {
      id: '4ac882c8-ecc1-4e42-8008-bef3606ef1c5',
      type: 'Text',
      name: 'altThirdTitle',
      className: '',
      x: -2.85,
      y: -410,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      scale: {
        x: 0.95,
        y: 0.95
      },
      angle: 0,
      alpha: 0,
      visible: true,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      text: 'Try Again?',
      localize: true,
      maxWidth: 440,
      maxHeight: 168,
      maxFontSize: 0,
      icons: [],
      style: {
        fontSize: 80,
        fontWeight: 'normal',
        fontFamily: 'Baloo{wf}',
        fill: 'white',
        stroke: '0x840025',
        strokeThickness: 7,
        align: 'left',
        wordWrap: false,
        wordWrapWidth: 100,
        breakWords: false,
        lineHeight: 0,
        padding: 0,
        fontStyle: 'normal',
        dropShadow: false,
        dropShadowAlpha: 1,
        dropShadowAngle: 0,
        dropShadowBlur: 0,
        dropShadowColor: 'black',
        dropShadowDistance: 5,
        leading: 0,
        lineJoin: 'round',
        miterLimit: 10,
        trim: false,
        textBaseline: 'alphabetic',
        whiteSpace: 'pre',
        fontVariant: 'normal',
        letterSpacing: 0,
        fillGradientStops: [],
        fillGradientType: 0
      },
      parent: 'b072aa80-294b-4346-b14e-9e3d226ff3b2',
      stateByName: {
        retryFlow: {
          alpha: 0
        }
      }
    },
    {
      id: '3c561bc3-0fbf-4471-a474-814847c2b7d9',
      type: 'NineSlicePlane',
      name: '',
      className: '',
      x: -270,
      y: -72,
      scale: {
        x: 1,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      width: 538,
      height: 144,
      leftWidth: 73,
      topHeight: 0,
      rightWidth: 73,
      bottomHeight: 0,
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'PopUp_Button_Background_9Slice_73x0x73x0',
      parent: '0ee2f63e-f667-46ca-9ec5-bea53af51e77'
    },
    {
      id: 'b3558d03-5ade-4a07-8bf7-b89d58b9f456',
      type: 'Layout',
      name: '',
      className: '',
      path: 'common/buttons/ButtonExtraLargeLayout.ts',
      percentX: 0,
      percentY: 0,
      handleResize: false,
      x: 0,
      y: 0,
      scale: {
        x: 1.2,
        y: 1.2
      },
      pivot: {
        x: 0,
        y: 0
      },
      angle: 0,
      alpha: 1,
      visible: true,
      interactive: false,
      buttonMode: false,
      parent: '0ee2f63e-f667-46ca-9ec5-bea53af51e77',
      data: {
        color: 'green',
        tapSound: 'UI_Button_Click'
      }
    },
    {
      id: '73f1f9b7-01db-485e-a06a-929af67c6092',
      type: 'Text',
      name: '',
      className: '',
      x: -75,
      y: -5,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      text: 'Play On',
      localize: true,
      maxWidth: 278,
      maxHeight: 106,
      maxFontSize: 0,
      icons: [],
      style: {
        fontSize: 70,
        fontWeight: 'normal',
        fontFamily: 'Baloo{wf}',
        fill: '#eaffe6',
        stroke: '#006f0d',
        strokeThickness: 7,
        align: 'left',
        wordWrap: false,
        wordWrapWidth: 100,
        breakWords: false,
        lineHeight: 0,
        padding: 0,
        fontStyle: 'normal',
        dropShadow: false,
        dropShadowAlpha: 1,
        dropShadowAngle: 0,
        dropShadowBlur: 0,
        dropShadowColor: 'black',
        dropShadowDistance: 5,
        leading: 0,
        lineJoin: 'round',
        miterLimit: 10,
        trim: false,
        textBaseline: 'alphabetic',
        whiteSpace: 'pre',
        fontVariant: 'normal',
        letterSpacing: 0,
        fillGradientStops: [],
        fillGradientType: 0
      },
      parent: '0ee2f63e-f667-46ca-9ec5-bea53af51e77'
    },
    {
      id: '5aaffc80-1942-4b2d-82c7-9803074007a6',
      type: 'Container',
      name: 'priceLabelContainer',
      className: '',
      x: 108,
      y: 0,
      scale: {
        x: 1,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      angle: 0,
      alpha: 1,
      visible: true,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      parent: '0ee2f63e-f667-46ca-9ec5-bea53af51e77'
    },
    {
      id: 'e59a49c2-f9b1-491a-9729-1fac020eed86',
      type: 'NineSlicePlane',
      name: '',
      className: '',
      x: -270,
      y: -72,
      scale: {
        x: 1,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      width: 538,
      height: 144,
      leftWidth: 73,
      topHeight: 0,
      rightWidth: 73,
      bottomHeight: 0,
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'PopUp_Button_Background_9Slice_73x0x73x0',
      parent: '0aaa51df-815a-4ca6-97c2-f10a31c94291'
    },
    {
      id: 'f8256efe-c1a3-4722-9a77-412c30a4b83d',
      type: 'Layout',
      name: '',
      className: '',
      path: 'common/buttons/ButtonExtraLargeLayout.ts',
      percentX: 0,
      percentY: 0,
      handleResize: false,
      x: 0,
      y: 0,
      scale: {
        x: 1.2,
        y: 1.2
      },
      pivot: {
        x: 0,
        y: 0
      },
      angle: 0,
      alpha: 1,
      visible: true,
      interactive: false,
      buttonMode: false,
      parent: '0aaa51df-815a-4ca6-97c2-f10a31c94291',
      data: {
        color: 'blue',
        tapSound: 'UI_Button_Click'
      }
    },
    {
      id: '08213837-d152-4663-bbd6-24baf8f7e1ea',
      type: 'Text',
      name: '',
      className: '',
      x: -75,
      y: -5,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      text: 'Play On',
      localize: true,
      maxWidth: 278,
      maxHeight: 106,
      maxFontSize: 0,
      icons: [],
      style: {
        fontSize: 70,
        fontWeight: 'normal',
        fontFamily: 'Baloo{wf}',
        fill: 'white',
        stroke: '#0038f0',
        strokeThickness: 7,
        align: 'left',
        wordWrap: false,
        wordWrapWidth: 100,
        breakWords: false,
        lineHeight: 0,
        padding: 0,
        fontStyle: 'normal',
        dropShadow: false,
        dropShadowAlpha: 1,
        dropShadowAngle: 0,
        dropShadowBlur: 0,
        dropShadowColor: 'black',
        dropShadowDistance: 5,
        leading: 0,
        lineJoin: 'round',
        miterLimit: 10,
        trim: false,
        textBaseline: 'alphabetic',
        whiteSpace: 'pre',
        fontVariant: 'normal',
        letterSpacing: 0,
        fillGradientStops: [],
        fillGradientType: 0
      },
      parent: '0aaa51df-815a-4ca6-97c2-f10a31c94291'
    },
    {
      id: '8c5ea984-983b-43ba-846e-fe55cc0c1e3c',
      type: 'Sprite',
      name: '',
      className: '',
      x: 153,
      y: -9,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1.5,
        y: 1.5
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'Watch_Ad_Icon_2',
      parent: '0aaa51df-815a-4ca6-97c2-f10a31c94291'
    },
    {
      id: '4f12fe8f-acc3-40b3-bab7-d8433a863f08',
      type: 'NineSlicePlane',
      name: '',
      className: '',
      x: -270,
      y: -73,
      scale: {
        x: 1,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      width: 538,
      height: 144,
      leftWidth: 73,
      topHeight: 0,
      rightWidth: 73,
      bottomHeight: 0,
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'PopUp_Button_Background_9Slice_73x0x73x0',
      parent: 'f7dc1155-12bf-4cd6-8eb7-5df882f78122'
    },
    {
      id: 'dc7fef81-2128-4df8-8b44-0e06bd4e825f',
      type: 'Layout',
      name: '',
      className: '',
      path: 'common/buttons/ButtonExtraLargeLayout.ts',
      percentX: 0,
      percentY: 0,
      handleResize: false,
      x: 0,
      y: 0,
      scale: {
        x: 1.2,
        y: 1.2
      },
      pivot: {
        x: 0,
        y: 0
      },
      angle: 0,
      alpha: 1,
      visible: true,
      interactive: false,
      buttonMode: false,
      parent: 'f7dc1155-12bf-4cd6-8eb7-5df882f78122',
      data: {
        color: 'green',
        tapSound: 'UI_Button_Click'
      }
    },
    {
      id: '8f9a93f1-2ca6-432c-b804-bc629d67f750',
      type: 'Text',
      name: '',
      className: '',
      x: 0,
      y: -5,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      text: 'Retry',
      localize: true,
      maxWidth: 373,
      maxHeight: 106,
      maxFontSize: 0,
      icons: [],
      style: {
        fontSize: 72,
        fontWeight: 'normal',
        fontFamily: 'Baloo{wf}',
        fill: '#eaffe6',
        stroke: '#006f0d',
        strokeThickness: 7,
        align: 'left',
        wordWrap: false,
        wordWrapWidth: 100,
        breakWords: false,
        lineHeight: 0,
        padding: 0,
        fontStyle: 'normal',
        dropShadow: false,
        dropShadowAlpha: 1,
        dropShadowAngle: 0,
        dropShadowBlur: 0,
        dropShadowColor: 'black',
        dropShadowDistance: 5,
        leading: 0,
        lineJoin: 'round',
        miterLimit: 10,
        trim: false,
        textBaseline: 'alphabetic',
        whiteSpace: 'pre',
        fontVariant: 'normal',
        letterSpacing: 0,
        fillGradientStops: [],
        fillGradientType: 0
      },
      parent: 'f7dc1155-12bf-4cd6-8eb7-5df882f78122'
    },
    {
      id: '1ab3c89f-5ec8-4582-bc44-f1a468a78094',
      type: 'NineSlicePlane',
      name: '',
      className: '',
      x: -274,
      y: -80,
      scale: {
        x: 1,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      width: 548,
      height: 160,
      leftWidth: 64,
      topHeight: 0,
      rightWidth: 64,
      bottomHeight: 0,
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'Button_Background',
      parent: 'b83ced11-0a9e-4908-879d-cfc917262a5f'
    },
    {
      id: 'f71241ef-c5eb-4689-bc6b-bca1a490baab',
      type: 'Layout',
      name: '',
      className: '',
      path: 'common/buttons/ButtonExtraLargeLayout.ts',
      percentX: 0,
      percentY: 0,
      handleResize: false,
      x: 0,
      y: 0,
      scale: {
        x: 1.2,
        y: 1.2
      },
      pivot: {
        x: 0,
        y: 0
      },
      angle: 0,
      alpha: 1,
      visible: true,
      interactive: false,
      buttonMode: false,
      parent: 'b83ced11-0a9e-4908-879d-cfc917262a5f',
      data: {
        color: 'red',
        tapSound: 'UI_Button_Click'
      }
    },
    {
      id: '70705b46-bec6-47e5-8a6c-6f09f14a23e7',
      type: 'Text',
      name: '',
      className: '',
      x: 0,
      y: -5,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      text: 'Quit Level',
      localize: true,
      maxWidth: 373,
      maxHeight: 106,
      maxFontSize: 0,
      icons: [],
      style: {
        fontSize: 72,
        fontWeight: 'normal',
        fontFamily: 'Baloo{wf}',
        fill: '#eaffe6',
        stroke: '0x9c1131',
        strokeThickness: 7,
        align: 'left',
        wordWrap: false,
        wordWrapWidth: 100,
        breakWords: false,
        lineHeight: 0,
        padding: 0,
        fontStyle: 'normal',
        dropShadow: false,
        dropShadowAlpha: 1,
        dropShadowAngle: 0,
        dropShadowBlur: 0,
        dropShadowColor: 'black',
        dropShadowDistance: 5,
        leading: 0,
        lineJoin: 'round',
        miterLimit: 10,
        trim: false,
        textBaseline: 'alphabetic',
        whiteSpace: 'pre',
        fontVariant: 'normal',
        letterSpacing: 0,
        fillGradientStops: [],
        fillGradientType: 0
      },
      parent: 'b83ced11-0a9e-4908-879d-cfc917262a5f'
    },
    {
      id: '9b5958ed-5015-484a-be45-3767c33b3209',
      type: 'Sprite',
      name: '',
      className: '',
      x: -16,
      y: -28,
      anchor: {
        x: 0,
        y: 0
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1.3,
        y: 1.3
      },
      angle: 0,
      alpha: 0.4,
      visible: true,
      tint: 0,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'Coin_Field',
      parent: '5aaffc80-1942-4b2d-82c7-9803074007a6'
    },
    {
      id: '8628dff6-a686-4218-be0a-279fd02b72e0',
      type: 'Sprite',
      name: '',
      className: '',
      x: 0,
      y: 0,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'Coin_Icon',
      parent: '5aaffc80-1942-4b2d-82c7-9803074007a6'
    },
    {
      id: '3a8761d1-f1a2-4c83-a467-e20729b6cc6c',
      type: 'Text',
      name: 'priceText',
      className: '',
      x: 77,
      y: 3,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      text: 'XXX',
      localize: false,
      maxWidth: 122,
      maxHeight: 68,
      maxFontSize: 36,
      icons: [],
      style: {
        fontSize: 36,
        fontWeight: 'normal',
        fontFamily: 'Baloo{wf}',
        fill: '#eaffe6',
        stroke: 'black',
        strokeThickness: 0,
        align: 'left',
        wordWrap: false,
        wordWrapWidth: 100,
        breakWords: false,
        lineHeight: 0,
        padding: 5,
        fontStyle: 'normal',
        dropShadow: false,
        dropShadowAlpha: 1,
        dropShadowAngle: 0,
        dropShadowBlur: 0,
        dropShadowColor: 'black',
        dropShadowDistance: 5,
        leading: 0,
        lineJoin: 'round',
        miterLimit: 10,
        trim: false,
        textBaseline: 'alphabetic',
        whiteSpace: 'pre',
        fontVariant: 'normal',
        letterSpacing: 0,
        fillGradientStops: [],
        fillGradientType: 0
      },
      parent: '5aaffc80-1942-4b2d-82c7-9803074007a6'
    }
  ],
  x: 0,
  y: 0,
  width: 664,
  height: 667,
  version: '1.0.0',
  stateNames: [
    'unlimitedLives',
    'retryFlow',
    'adButton',
    'retryFlowUnlimitedLives'
  ],
  animations: [
    {
      id: '902cef8d-b1d3-405b-9bf3-4b98abb06315',
      name: 'switchToAreYouSure',
      playingSpeed: 1,
      totalDuration: 400,
      blocks: [
        {
          id: '5ddfa1c0-e29d-4910-ae6f-b8129c80f236',
          type: 'Tween',
          name: 'goalsContainerAlpha_0',
          duration: 200,
          track: 1,
          target: {
            alpha: 0
          },
          startAt: 0,
          sourceName: 'goalsContainer',
          easing: 'SinusoidalIn',
          disabled: false
        },
        {
          id: '3d587531-2b78-4091-8b80-c2c1dc036e98',
          type: 'Tween',
          name: 'outOfSpaceTitleAlpha_0',
          duration: 200,
          track: 5,
          target: {
            alpha: 0
          },
          startAt: 0,
          sourceName: 'outOfSpaceTitle',
          easing: 'SinusoidalIn',
          disabled: false
        },
        {
          id: '558bb05f-625b-47f5-9a1c-70aac33e16c2',
          type: 'Tween',
          name: 'areYouSureLayoutAlpha_0',
          duration: 300,
          track: 3,
          target: {
            alpha: 1
          },
          startAt: 100,
          sourceName: 'areYouSureLayout',
          easing: 'SinusoidalIn',
          disabled: false
        },
        {
          id: '20ed737f-f0b4-4507-a665-27ac56be3485',
          type: 'Tween',
          name: 'secondTitleAlpha_0',
          duration: 300,
          track: 2,
          target: {
            alpha: 1
          },
          startAt: 101,
          sourceName: 'secondTitle',
          easing: 'SinusoidalIn',
          disabled: false
        }
      ]
    },
    {
      id: 'b7810110-745b-4666-8964-40c47c34da66',
      name: 'switchToLifeLost',
      playingSpeed: 1,
      totalDuration: 1000,
      blocks: [
        {
          id: '091f65d5-6524-4b53-aea6-1b75ba8ea6c2',
          type: 'Setter',
          name: 'setAreYouSureLayoutAlpha',
          track: 2,
          target: {
            alpha: 1
          },
          startAt: 0,
          sourceName: 'areYouSureLayout',
          disabled: false
        },
        {
          id: '9d82ec27-241d-4185-8faa-28c7a81b1e26',
          type: 'Setter',
          name: 'setClearLayoutAlpha',
          track: 1,
          target: {
            alpha: 0
          },
          startAt: 0,
          sourceName: 'clearLayout',
          disabled: false
        },
        {
          id: 'f07cebef-1084-4b8f-b15e-79bb84c38fcb',
          type: 'Setter',
          name: 'setTitleAlpha',
          track: 2,
          target: {
            alpha: 0
          },
          startAt: 0,
          sourceName: 'title',
          disabled: false
        },
        {
          id: '176f51f6-1af1-4df6-900e-79d467349228',
          type: 'Tween',
          name: 'lifeLostLayoutAlpha_0',
          duration: 200,
          track: 3,
          target: {
            alpha: 1
          },
          startAt: 0,
          sourceName: 'lifeLostLayout',
          easing: 'SinusoidalIn',
          disabled: false
        },
        {
          id: '42c3bc75-db65-4f77-8f24-44563aad7ecb',
          type: 'Tween',
          name: 'playButtonAlpha_0',
          duration: 200,
          track: 6,
          target: {
            alpha: 0
          },
          startAt: 0,
          sourceName: 'playButton',
          easing: 'Linear',
          disabled: false
        },
        {
          id: 'e2f17e52-39d1-42a2-932d-afc2db42b4ae',
          type: 'Tween',
          name: 'setSecondTitleAlpha_0',
          duration: 150,
          track: 7,
          target: {
            alpha: 0
          },
          startAt: 0,
          sourceName: 'secondTitle',
          easing: 'SinusoidalIn',
          disabled: false
        },
        {
          id: 'a9f430f2-51f7-4c5a-be85-2cadb98870f5',
          type: 'Tween',
          name: 'closeButtonAlpha_0',
          duration: 150,
          track: 10,
          target: {
            alpha: 0
          },
          startAt: 0,
          sourceName: 'closeButton',
          easing: 'SinusoidalIn',
          disabled: false
        },
        {
          id: '77da02fc-89a2-46b0-b8f1-b3e8d6c7bb48',
          type: 'Tween',
          name: 'adButtonAlpha_0',
          duration: 200,
          track: 5,
          target: {
            alpha: 0
          },
          startAt: 0,
          sourceName: 'adButton',
          easing: 'Linear',
          disabled: false
        },
        {
          id: 'd60ceb6a-4d76-42f0-a71c-b156a1470c8b',
          type: 'Tween',
          name: 'quitButtonAlpha_0',
          duration: 200,
          track: 4,
          target: {
            alpha: 0
          },
          startAt: 0,
          sourceName: 'quitButton',
          easing: 'Linear',
          disabled: false
        },
        {
          id: 'd64ffa21-650f-4724-ba9d-0153e296ca38',
          type: 'Setter',
          name: 'setSecondTitleAlpha',
          track: 1,
          target: {
            alpha: 1
          },
          startAt: 1,
          sourceName: 'secondTitle',
          disabled: false
        },
        {
          id: 'bfd38c81-39bd-4085-93bf-07a5472d6110',
          type: 'Tween',
          name: 'setThirdTitleAlpha_0',
          duration: 300,
          track: 8,
          target: {
            alpha: 1
          },
          startAt: 101,
          sourceName: 'thirdTitle',
          easing: 'SinusoidalIn',
          disabled: false
        },
        {
          id: '3486c18a-7b8a-41e8-9050-47958d99ef8b',
          type: 'Setter',
          name: 'ANIMEVENT_updateButtons',
          track: 10,
          target: {},
          startAt: 169,
          sourceName: 'root',
          disabled: false
        },
        {
          id: '2e2fe13b-542b-4b00-9fdc-767f9bbc16ba',
          type: 'Setter',
          name: 'ANIMEVENT_playHeartAnimation',
          track: 9,
          target: {},
          startAt: 194,
          sourceName: 'root',
          disabled: false
        },
        {
          id: '4493385b-c806-4c1f-b34a-d24081fba8e0',
          type: 'Tween',
          name: 'closeButtonAlpha_1',
          duration: 250,
          track: 10,
          target: {
            alpha: 1
          },
          startAt: 195,
          sourceName: 'closeButton',
          easing: 'SinusoidalIn',
          disabled: false
        },
        {
          id: 'a278daa7-165a-4628-ae77-2cf3c0bffefb',
          type: 'Tween',
          name: 'areYouSureLayoutAlpha_0',
          duration: 200,
          track: 3,
          target: {
            alpha: 0
          },
          startAt: 200,
          sourceName: 'areYouSureLayout',
          easing: 'SinusoidalIn',
          disabled: false
        },
        {
          id: '4c83a735-3243-4e35-ada2-7a8355c3505b',
          type: 'Tween',
          name: 'retryButtonAlpha_0',
          duration: 200,
          track: 6,
          target: {
            alpha: 1
          },
          startAt: 261,
          sourceName: 'retryButton',
          easing: 'Linear',
          disabled: false
        }
      ]
    },
    {
      id: 'f30c8bfd-f38c-4fc5-bfec-7e9ef601cee7',
      name: 'switchToAreYouSure_UnlimitedLives',
      playingSpeed: 1,
      totalDuration: 1000,
      blocks: [
        {
          id: 'c2e0324a-588e-48ed-8f2a-e3e0cbf75931',
          type: 'Tween',
          name: 'outOfSpaceTitleAlpha_0_1',
          duration: 200,
          track: 2,
          target: {
            alpha: 0
          },
          startAt: 0,
          sourceName: 'outOfSpaceTitle',
          easing: 'SinusoidalIn',
          disabled: false
        },
        {
          id: '7112d3d8-8d0d-403f-81db-c44944fbd9de',
          type: 'Tween',
          name: 'secondTitleAlpha_0_1',
          duration: 300,
          track: 1,
          target: {
            alpha: 1
          },
          startAt: 101,
          sourceName: 'secondTitle',
          easing: 'SinusoidalIn',
          disabled: false
        }
      ]
    },
    {
      id: 'e4580b75-b469-4991-86e8-e108f4df4526',
      name: 'switchToLifeLost_UnlimitedLives',
      playingSpeed: 1,
      totalDuration: 1000,
      blocks: [
        {
          id: '03e1d8ae-9256-4e44-a6fc-39f584af8a1c',
          type: 'Tween',
          name: 'lifeLostLayoutAlpha_1',
          duration: 200,
          track: 1,
          target: {
            alpha: 1
          },
          startAt: 0,
          sourceName: 'lifeLostLayout',
          easing: 'SinusoidalIn',
          disabled: false
        },
        {
          id: '2c6b0f76-bd02-421a-8d41-4b34d469252d',
          type: 'Tween',
          name: 'adButtonAlpha_1',
          duration: 200,
          track: 3,
          target: {
            alpha: 0
          },
          startAt: 0,
          sourceName: 'adButton',
          easing: 'Linear',
          disabled: false
        },
        {
          id: 'd4b9e9c9-9aca-4ce8-987a-03686bf2930a',
          type: 'Tween',
          name: 'setSecondTitleAlpha_1',
          duration: 150,
          track: 6,
          target: {
            alpha: 0
          },
          startAt: 0,
          sourceName: 'secondTitle',
          easing: 'SinusoidalIn',
          disabled: false
        },
        {
          id: 'b1c26855-f5b0-4fdf-80d8-fe9c99c61088',
          type: 'Tween',
          name: 'playButtonAlpha_1',
          duration: 200,
          track: 4,
          target: {
            alpha: 0
          },
          startAt: 0,
          sourceName: 'playButton',
          easing: 'Linear',
          disabled: false
        },
        {
          id: '6e8860bb-e4eb-40d1-aa9c-400b6471e5cc',
          type: 'Tween',
          name: 'quitButtonAlpha_1',
          duration: 200,
          track: 2,
          target: {
            alpha: 0
          },
          startAt: 0,
          sourceName: 'quitButton',
          easing: 'Linear',
          disabled: false
        },
        {
          id: 'f06728d3-47fe-461d-b82c-ba7cb8ecdfa2',
          type: 'Tween',
          name: 'setAltThirdTitleAlpha_1',
          duration: 300,
          track: 7,
          target: {
            alpha: 1
          },
          startAt: 101,
          sourceName: 'altThirdTitle',
          easing: 'SinusoidalIn',
          disabled: false
        },
        {
          id: 'b6e9c202-b8b8-415e-a854-2f3c8855bed8',
          type: 'Setter',
          name: 'ANIMEVENT_updateButtons',
          track: 5,
          target: {},
          startAt: 169,
          sourceName: 'root',
          disabled: false
        },
        {
          id: '2808b0ef-1357-4a3c-9ae4-eda6cac8815d',
          type: 'Tween',
          name: 'retryButtonAlpha_1',
          duration: 200,
          track: 4,
          target: {
            alpha: 1
          },
          startAt: 247,
          sourceName: 'retryButton',
          easing: 'Linear',
          disabled: false
        }
      ]
    }
  ],
  handleResize: false
} as const;

export class FailPopupLayout {
  static raw = raw;
  root!: Container;
  popup!: Container;
  background!: NineSlicePlane;
  outOfSpaceContainer!: Container;
  areYouSureContainer!: Container;
  lifeLostContainer!: Container;
  closeButton!: Sprite & { data: typeof raw['list'][7]['data'] };
  playButton!: Container & { data: typeof raw['list'][8]['data'] };
  adButton!: Container & { data: typeof raw['list'][9]['data'] };
  retryButton!: Container & { data: typeof raw['list'][10]['data'] };
  quitButton!: Container & { data: typeof raw['list'][11]['data'] };
  offerSlot!: Container;
  outOfSpaceLayout!: OutOfSpaceProgressLayout;
  outOfSpaceTitle!: Text;
  areYouSureLayout!: AreYouSureLayout;
  secondTitle!: Text;
  lifeLostLayout!: YouLostALifeLayout;
  thirdTitle!: Text;
  altThirdTitle!: Text;
  priceLabelContainer!: Container;
  priceText!: Text;
  StateName!: 'unlimitedLives' | 'retryFlow' | 'adButton' | 'retryFlowUnlimitedLives';

  constructor() {
    populate(this, raw);
  }
}

export abstract class switchToAreYouSure {
  Layout: {
    goalsContainer: object;
    outOfSpaceTitle: object;
    areYouSureLayout: object;
    secondTitle: object;
  };

  BlockTypeByName: {
    goalsContainerAlpha_0: object;
    outOfSpaceTitleAlpha_0: object;
    areYouSureLayoutAlpha_0: object;
    secondTitleAlpha_0: object;
  };

  flowData = raw.animations[0];
}

export abstract class switchToLifeLost {
  Layout: {
    areYouSureLayout: object;
    clearLayout: object;
    title: object;
    lifeLostLayout: object;
    playButton: object;
    secondTitle: object;
    closeButton: object;
    adButton: object;
    quitButton: object;
    thirdTitle: object;
    root: object;
    retryButton: object;
  };

  BlockTypeByName: {
    setAreYouSureLayoutAlpha: object;
    setClearLayoutAlpha: object;
    setTitleAlpha: object;
    lifeLostLayoutAlpha_0: object;
    playButtonAlpha_0: object;
    setSecondTitleAlpha_0: object;
    closeButtonAlpha_0: object;
    adButtonAlpha_0: object;
    quitButtonAlpha_0: object;
    setSecondTitleAlpha: object;
    setThirdTitleAlpha_0: object;
    ANIMEVENT_updateButtons: object;
    ANIMEVENT_playHeartAnimation: object;
    closeButtonAlpha_1: object;
    areYouSureLayoutAlpha_0: object;
    retryButtonAlpha_0: object;
  };

  flowData = raw.animations[1];
}

export abstract class switchToAreYouSure_UnlimitedLives {
  Layout: {
    outOfSpaceTitle: object;
    secondTitle: object;
  };

  BlockTypeByName: {
    outOfSpaceTitleAlpha_0_1: object;
    secondTitleAlpha_0_1: object;
  };

  flowData = raw.animations[2];
}

export abstract class switchToLifeLost_UnlimitedLives {
  Layout: {
    lifeLostLayout: object;
    adButton: object;
    secondTitle: object;
    playButton: object;
    quitButton: object;
    altThirdTitle: object;
    root: object;
    retryButton: object;
  };

  BlockTypeByName: {
    lifeLostLayoutAlpha_1: object;
    adButtonAlpha_1: object;
    setSecondTitleAlpha_1: object;
    playButtonAlpha_1: object;
    quitButtonAlpha_1: object;
    setAltThirdTitleAlpha_1: object;
    ANIMEVENT_updateButtons: object;
    retryButtonAlpha_1: object;
  };

  flowData = raw.animations[3];
}
